var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsResend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6v-2H3V6l6.94 4.34c.65.41 1.47.41 2.12 0L19 6v5h2V4c0-1.1-.9-2-2-2zm-8 7L3 4h16l-8 5zm6.648 4.685c0-.615.763-.915 1.2-.478l3.94 3.813c.283.273.283.697 0 .97l-3.94 3.812c-.437.424-1.2.123-1.2-.492v-2.446h-5.236c-.777 0-1.412-.615-1.412-1.366 0-.752.635-1.367 1.412-1.367h5.236v-2.446z",
    transform: "translate(-1147 -430) translate(104 193) translate(939 78) translate(104 159)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsResend);
export default __webpack_public_path__ + "static/media/icons-resend.7a7ba68c8587ac3ffac475d54bab8599.svg";
export { ForwardRef as ReactComponent };